const BACK_OFFICE_MASTER_DATA_URL = "/master-data/general-posting-group";

export default [
  {
    level: 3,
    key: "title.generalBusinessPostingGroup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/general-business-posting-group`,
  },
  {
    level: 3,
    key: "title.generalProductPostingGroup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/general-product-posting-group`,
  },
  {
    level: 3,
    key: "title.inventoryPostingGroup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/inventory-posting-group`,
  },
  {
    level: 3,
    key: "title.bankAccountPostingGroup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/bank-account-posting-group`,
  },
  {
    level: 3,
    key: "title.depositAccountPostingGroup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/deposit-account-posting-group`,
  },
  {
    level: 3,
    key: "title.clientPostingGroup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/client-posting-group`,
  },
  {
    level: 3,
    key: "title.vendorPostingGroup",
    link: `${BACK_OFFICE_MASTER_DATA_URL}/vendor-posting-group`,
  },
];
